import { FetchAPI } from "@renedelangel/helpers";
import { urlServidor } from '../../helpers';
import { GET_ALL_USUARIO } from '../Usuarios';

/* Catálogos de solo lectura para los seguimientos de siniestros */

export const GET_ALL_EJERCICIOSINIESTROS = `
query filtroGetAll($filtro: InputGetEjercicioSiniestros){
    getAllEjercicioSiniestros(filtro: $filtro){
        ejercicioID
        descripcion
        fechaInicio
        fechaFin
        estado
    }
}
`;

export const GET_ALL_SEMANASINIESTROS = `
query filtroGetAll($filtro: InputGetSemanaSiniestros){
    getAllSemanaSiniestros(filtro: $filtro){
        semanaID
        ejercicioID
        ejercicio
        numSemana
        fechaInicio
        fechaFin
        estado
    }
}
`;

export const GET_ALL_ESTADOSEGUIMIENTOSIN = `
query filtroGetAll($filtro: InputGetEstadoSeguimientoSin){
    getAllEstadoSeguimientoSin(filtro: $filtro){
        estadoID
        nombre
        color
        esFinal
        orden
    }
}
`;

export const getAllEjercicioSiniestros = async (variables, token) => {
    try {
        let { getAllEjercicioSiniestros } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: GET_ALL_EJERCICIOSINIESTROS
        });
        return getAllEjercicioSiniestros;
    } catch ({ message }) { throw new Error(message); }
}

export const getAllSemanaSiniestros = async (variables, token) => {
    try {
        let { getAllSemanaSiniestros } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: GET_ALL_SEMANASINIESTROS
        });
        return getAllSemanaSiniestros;
    } catch ({ message }) { throw new Error(message); }
}

export const GET_ALL_TIPOSEGUIMIENTOSIN = `
query filtroGetAll($filtro: InputGetTipoSeguimientoSin){
    getAllTipoSeguimientoSin(filtro: $filtro){
        tipoSeguimientoID
        nombre
        orden
    }
}
`;

export const getAllTipoSeguimientoSin = async (variables, token) => {
    try {
        let { getAllTipoSeguimientoSin } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: GET_ALL_TIPOSEGUIMIENTOSIN
        });
        return getAllTipoSeguimientoSin;
    } catch ({ message }) { throw new Error(message); }
}

export const seleccionTipoSeguimientoSin = async (variables, token) => {
    try {
        let allTipos = await getAllTipoSeguimientoSin(variables, token);
        if (!Array.isArray(allTipos)) throw new Error("No se encontraron registros");

        return allTipos.map(({ tipoSeguimientoID: value, nombre: label }) => ({ value, label: String(label).toUpperCase() }));
    } catch ({ message: label }) {
        return [{ label, value: null, disabled: true }];
    }
}

export const getAllEstadoSeguimientoSin = async (variables, token) => {
    try {
        let { getAllEstadoSeguimientoSin } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: GET_ALL_ESTADOSEGUIMIENTOSIN
        });
        return getAllEstadoSeguimientoSin;
    } catch ({ message }) { throw new Error(message); }
}

export const seleccionEjercicioSiniestros = async (variables, token) => {
    try {
        let allEjercicios = await getAllEjercicioSiniestros(variables, token);
        if (!Array.isArray(allEjercicios)) throw new Error("No se encontraron registros");

        return allEjercicios.map(({ ejercicioID: value, descripcion: label, fechaInicio, fechaFin, estado }) => ({
            value,
            label: String(label).toUpperCase(),
            fechaInicio,
            fechaFin,
            estado
        }));
    } catch ({ message: label }) {
        return [{ label, value: null, disabled: true }];
    }
}

export const seleccionSemanaSiniestros = async (variables, token) => {
    try {
        let allSemanas = await getAllSemanaSiniestros(variables, token);
        if (!Array.isArray(allSemanas)) throw new Error("No se encontraron registros");

        return allSemanas.map(({ semanaID: value, numSemana, ejercicioID, fechaInicio, fechaFin, estado }) => ({
            value,
            label: `SEMANA ${numSemana}`,
            ejercicioID,
            numSemana,
            fechaInicio,
            fechaFin,
            estado
        }));
    } catch ({ message: label }) {
        return [{ label, value: null, disabled: true }];
    }
}

export const seleccionEstadoSeguimientoSin = async (variables, token) => {
    try {
        let allEstados = await getAllEstadoSeguimientoSin(variables, token);
        if (!Array.isArray(allEstados)) throw new Error("No se encontraron registros");

        return allEstados.map(({ estadoID: value, nombre: label, color, esFinal }) => ({
            value,
            label: String(label).toUpperCase(),
            color,
            esFinal
        }));
    } catch ({ message: label }) {
        return [{ label, value: null, disabled: true }];
    }
}

export const seleccionUsuarios = async (variables, token) => {
    try {
        let { getAllUsuario } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: GET_ALL_USUARIO
        });
        if (!Array.isArray(getAllUsuario)) throw new Error("No se encontraron registros");

        return getAllUsuario.map(({ usuarioID: value, usuario: label }) => ({ value, label: String(label).toUpperCase() }));
    } catch ({ message: label }) {
        return [{ label, value: null, disabled: true }];
    }
}
